export default __webpack_public_path__ + "static/media/privacy.0de36bec.svg";